var map = {
	"./package-1.svg": 1583,
	"./package-10.svg": 824,
	"./package-2.svg": 1584,
	"./package-3.svg": 1585,
	"./package-4.svg": 1586,
	"./package-5.svg": 1587,
	"./package-6.svg": 1588,
	"./package-7.svg": 1589,
	"./package-8.svg": 1590,
	"./package-9.svg": 1591
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 425;